export const STREAMS = [
  {
    id: 66,
    name: "homolog",
    label: "HOMOLOG",
    brand: "somalabs",
    sales_channel: "1",
  },
  {
    id: 24,
    name: "aovivo",
    label: "FARM",
    brand: "farm",
    sales_channel: "6",
  },
  {
    id: 56,
    name: "ecommerce",
    label: "FARM - ECOMMERCE",
    brand: "farm",
    sales_channel: "6",
  },
  {
    id: 58,
    name: "styling-sessions",
    label: "ANIMALE",
    brand: "animale",
    sales_channel: "1",
  },
  {
    id: 59,
    name: "crisbarros-desfile-aw23",
    label: "CRIS BARROS",
    brand: "crisbarros",
    sales_channel: "1",
  },
  {
    id: 26,
    name: "outletpremium",
    label: "OFF PREMIUM",
    brand: "offpremium",
    sales_channel: "1",
  },
  {
    id: 46,
    name: "live",
    label: "MARIA FILÓ",
    brand: "mariafilo",
    sales_channel: "1",
  },
];
